import StagesForm from './StagesForm';

export default StagesForm;
